import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";

function AuditFormPrivewUi({ values }) {
  const [mappedValues, setMappedValues] = useState([]);
  useEffect(() => {
    // Calculate the difference between b and a
    const difference = values?.max - values?.min;
    // Create an array of mapped values
    const valuesT = [];
    for (let i = 0; i <= difference; i++) {
      const mappedValue = values?.min + i;
      valuesT.push(mappedValue);
    }
    // Set the mapped values to state
    if (valuesT.length > 1) {
      setMappedValues(valuesT);
    }
  }, [values?.min, values?.max]);

  return (
    <div>
      <h4 className="p-2 ">Preview </h4>
      <div className=" px-3 " style={{ width: "40%" }}>
        {values?.question ? (
          <p>
            <strong>Q. {values?.question}</strong>
          </p>
        ) : null}
        {values?.input_type === "date" && (
             <div className="d-flex date" style={{width:"100%"}}>        
             <DatePicker
               selected={new Date()}
               dateFormat="dd/MM/yyyy" // Adjust format as needed
               placeholderText="Select a date"
             />
             <div className="input-group-append">
               <div className="input-group-text">
                 <i className="fa fa-calendar"></i>
               </div>
             </div>
           </div>
        )}
        {values?.input_type === "text" && (
          <input
            type="text"
            className="form-control"
            placeholder="Text Input Preview"
            disabled
          />
        )}

        {values?.input_type === "dropdown" && (
          <>
            <select className="form-control" disabled>
              <option value="">Select an option</option>
              {values?.options?.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {values?.dropdown_type === "custom" ? (
              <ul className="bg-secondary" style={{ borderRadius: "5px" }}>
                {values?.options?.map((value, index) => (
                  <li>{value}</li>
                ))}
              </ul>
            ) : null}
            {values?.dropdown_type === "numeric" ? (
              <ul className="bg-secondary" tyle={{ borderRadius: "5px" }}>
                {mappedValues?.length > 1 &&
                  mappedValues?.map((value, index) => <li>{value}</li>)}
              </ul>
            ) : null}
            {values?.dropdown_type === "autogenerate" ? (
              <ul className="bg-secondary">
                {mappedValues?.map((value, index) => (
                  <li tyle={{ borderRadius: "5px" }}>
                    {values?.title} {value}
                  </li>
                ))}
              </ul>
            ) : null}
          </>
        )}

        {values?.input_type === "checkbox" &&
          values?.checkbox_type === "single" && (
            <div className="d-flex">
              {values?.options?.map((option, index) => (
                <div className="form-check mr-3" key={index}>
                  <input
                    type="checkbox"
                    className="form-check-input "
                    id={`checkbox-${index}`}
                    //   disabled
                  />
                  <label
                    className="form-check-label "
                    htmlFor={`checkbox-${index}`}
                  >
                    {option}
                  </label>
                </div>
              ))}
            </div>
          )}

        {values?.input_type === "radio" && (
          <div className="d-flex">
            {values?.options?.map((option, index) => (
              <div className="form-check mr-3" key={index}>
                <input
                  type="radio"
                  className="form-check-input"
                  id={`radio-${index}`}
                  name="preview-radio"
                  //   disabled
                />
                <label className="form-check-label " htmlFor={`radio-${index}`}>
                  {option}
                </label>
              </div>
            ))}
          </div>
        )}

        {/* Sub Questin */}
        {values?.input_type === "checkbox" && values?.checkbox_type === "multiple"
          ? values?.sub_question?.map((val) => (
              <div className="px-3">
                {val?.question ? (
                  <p>
                    <strong>Sub Q. {val?.question}</strong>
                  </p>
                ) : null}
                {val?.input_type === "text" && (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Text Input Preview"
                    disabled
                  />
                )}
                {val?.input_type === "dropdown" && (
                  <>
                    <select className="form-control" disabled>
                      <option value="">Select an option</option>
                      {val?.options?.map((option, index) => (
                        <option
                          key={index}
                          value={option}
                          style={{ borderRadius: "10px" }}
                        >
                          {option}
                        </option>
                      ))}
                    </select>
                    {val?.dropdown_type === "custom" ? (
                      <ul
                        className="bg-secondary"
                        style={{ borderRadius: "5px" }}
                      >
                        {val?.options?.map((value, index) => (
                          <li>{value}</li>
                        ))}
                      </ul>
                    ) : null}
                    {val?.dropdown_type === "numeric" ? (
                      <ul
                        className="bg-secondary"
                        style={{ borderRadius: "5px" }}
                      >
                        {mappedValues?.map((value, index) => (
                          <li>{value}</li>
                        ))}
                      </ul>
                    ) : null}
                    {val?.dropdown_type === "autogenerate" ? (
                      <ul
                        className="bg-secondary"
                        style={{ borderRadius: "5px" }}
                      >
                        {mappedValues?.map((value, index) => (
                          <li>
                            {values?.title} {value}
                          </li>
                        ))}
                      </ul>
                    ) : null}
                  </>
                )}

                {val?.input_type === "checkbox" && (
                  <div className="d-flex">
                    {val?.options?.map((option, index) => (
                      <div className="form-check mr-3" key={index}>
                        <input
                          type="checkbox"
                          className="form-check-input "
                          id={`checkbox-${index}`}
                          //   disabled
                        />
                        <label
                          className="form-check-label "
                          htmlFor={`checkbox-${index}`}
                        >
                          {option}
                        </label>
                      </div>
                    ))}
                  </div>
                )}

                {val?.input_type === "radio" && (
                  <div className="d-flex">
                    {val?.options?.map((option, index) => (
                      <div className="form-check mr-3" key={index}>
                        <input
                          type="radio"
                          className="form-check-input"
                          id={`radio-${index}`}
                          name="preview-radio"
                          //   disabled
                        />
                        <label
                          className="form-check-label "
                          htmlFor={`radio-${index}`}
                        >
                          {option}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))
          : ""}
      </div>
    </div>
  );
}

export default AuditFormPrivewUi;
